import React, { useContext, useState } from 'react';
import Dialog from 'src/components/common/Dialog.redesign';
import IOwner from 'src/models/IOwner';
import AddOwnershipPages from '../../TractComponents/AddOwnershipPages';
import SearchResult from 'src/models/OwnerSearchResult';
import OwnerLandingPage from '../../TractComponents/OwnerLandingPage';
import AddOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddOwnership';
import AddWIOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddWIOwnership';
import { useForm } from 'react-hook-form';
import { useFetch } from 'use-http';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import { AnyObject } from 'final-form';
import LeaseGenerationTractDetail from 'src/models/leasing/LeaseGenerationTractDetail';

interface IManageOwnerDialogStateProps {
    createOwnership?: boolean;

    saveAddData?: (values: AddOwnershipData | AddWIOwnershipData | IOwner) => void;
    onCloseDialog?: () => void;
}

const ManageOwnerDialog: React.FC<IManageOwnerDialogStateProps> = (props: IManageOwnerDialogStateProps) => {
    const { register, setValue, getValues, handleSubmit } = useForm();
    const { get, response } = useFetch();
    const appContext = useContext<IAppContextState>(AppContext);

    const [page, setPage] = useState<AddOwnershipPages>(AddOwnershipPages.AddOwnershipLandingPage);
    const [searchResults, setSearchResults] = useState<SearchResult[]>(undefined);
    const [ownerDetails, setOwnerDetails] = useState<IOwner>(undefined);
    const [ownerTracts, setOwnerTracts] = useState<Array<LeaseGenerationTractDetail>>([]);

    const onAttachOwner = () => {
        console.log('Set Owner Details', ownerDetails);
        if ((!!ownerDetails && props.createOwnership !== true) || (props.createOwnership === true && ownerTracts.length > 0)) {
            props.saveAddData(ownerDetails);
            initializeFormAndState();
            props.onCloseDialog();
        } else {
            window.alert(`Owner must have 'Open' tracts`);
        }
    };

    const initializeFormAndState = () => {
        setSearchResults(undefined);
        setPage(AddOwnershipPages.AddOwnershipLandingPage);
    };

    const selectOwner = (index: number) => {
        const owners = searchResults;
        if (!owners) {
            return;
        }
        for (let i = 0; i < owners.length; ++i) {
            const tempOwner = owners[i];
            if (tempOwner === undefined) {
                continue;
            }
            if (i !== index) {
                tempOwner.selected = false;
            } else {
                tempOwner.selected = tempOwner.selected ? false : true;
            }
            setValue(`owners[${i}]`, tempOwner);
        }
    };

    const getOwnerDetail = async (ownerLookupId: number) => {
        const result = await get(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leasegeneration/owner/${ownerLookupId}`);

        if (response.ok) {
            setOwnerDetails(result.ownerDetails);
            const found = result.tracts.find((tract: LeaseGenerationTractDetail) => (tract.leasedStatus === 'Open' && tract.type !== 'Surface'));
            if (found || !props.createOwnership) {
                setOwnerTracts(result.tracts);
            } else {
                setOwnerTracts([]);
            }
        }
    };

    const searchOwners = async (searchText: string) => {
        const result = await get(
            `v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owner-search/${searchText}/All`
        );

        if (response.ok) {
            setSearchResults(result);
        }
    };

    const submitOwner = (formValues: unknown) => {
        if (ownerTracts.length > 0) {
            const values = cleanValues(formValues) as AddOwnershipData;
            props.saveAddData(values);
        } else {
            window.alert('Owner must have unleased tracts');
            initializeFormAndState();
            props.onCloseDialog();
        }
    };

    const cleanValues = (values: AnyObject) => {
        console.log('clean values', values);
        if (values.ownerType) {
            values.ownerType = parseInt(values.ownerType + '', 10);
        }
        if (values.ownership && values.ownership.decimalInterest) {
            values.ownership.decimalInterest = parseFloat(values.ownership.decimalInterest + '');
        }
        return values;
    };

    return (
        <Dialog title={'Manage Owners'}>
            <form onSubmit={handleSubmit(submitOwner)}>
                <div style={{ display: 'flex', width: '60vw' }}>
                    {page === AddOwnershipPages.AddOwnershipLandingPage && (
                        <OwnerLandingPage
                            searchResults={searchResults}
                            ownerTracts={ownerTracts}
                            selectOwner={selectOwner}
                            turnPage={(addOwnershipPage) => setPage(addOwnershipPage)}
                            getOwnerDetail={getOwnerDetail}
                            onAttachOwner={onAttachOwner}
                            searchOwners={searchOwners}
                            register={register}
                            getValues={getValues}
                            setValue={setValue}
                        />
                    )}
                    {page === AddOwnershipPages.DeviationDecimalInterest && (
                        <span>WIP</span>
                    )}
                </div>
            </form>
        </Dialog>
    );
};

export default ManageOwnerDialog;


// WEBPACK FOOTER //
// ./src/components/project/sections/tract/dialogs/ManageOwnerDialog.tsx